// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";
import { getAnalytics } from "firebase/analytics";

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyCFG-GIwx2IXNn9bSDYL_9PyJvCSC0H3XE",
    authDomain: "barswipe-bs777.firebaseapp.com",
    projectId: "barswipe-bs777",
    storageBucket: "barswipe-bs777.firebasestorage.app",
    messagingSenderId: "878056260569",
    appId: "1:878056260569:web:5531d5e230dc9ef8220fc8",
    measurementId: "G-71BT2GZM0E"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Storage
const storage = getStorage(app);

// Initialize Analytics (only in browser)
let analytics = null;
if (typeof window !== 'undefined') {
  analytics = getAnalytics(app);
}

export { storage, analytics };
export default app;

